import FormattedMessage from 'I18n/components/FormattedMessage';
import withErrorBoundary from '../../hoc/withErrorBoundary';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalRules } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalMessage() {
  const approval = useApprovalContext();
  const {
    isPending,
    isApproved,
    isApprover,
    isLoading,
    isConcludedAndShouldRestartOnConclude,
    isUserStepApproved
  } = useApprovalConditions();
  if (!approval.data || isLoading || isConcludedAndShouldRestartOnConclude) {
    return null;
  }
  const {
    approvedCount,
    stepCount
  } = approval.meta;
  if (isPending) {
    if (isApprover && isUserStepApproved) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalMessage.APPROVAL_PENDING_APPROVER_STEP_APPROVED",
        options: {
          approvedCount,
          count: stepCount
        }
      });
    }
    if (approval.data.approvalRules === ApprovalRules.ANY_CAN_APPROVE) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalMessage.APPROVAL_PENDING_RULE_ANY",
        options: {
          firstName: approval.data.approvalSteps[0].approver.firstName,
          lastName: approval.data.approvalSteps[0].approver.lastName,
          approvedCount,
          count: stepCount
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalMessage.APPROVAL_PENDING",
      options: {
        firstName: approval.data.approvalSteps[0].approver.firstName,
        lastName: approval.data.approvalSteps[0].approver.lastName,
        approvedCount,
        count: stepCount
      }
    });
  }
  if (isApproved) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalMessage.APPROVED",
      options: {
        firstName: approval.data.approvalSteps[0].approver.firstName,
        lastName: approval.data.approvalSteps[0].approver.lastName,
        approvedCount,
        count: stepCount
      }
    });
  }
  return null;
}
export default withErrorBoundary(ApprovalMessage, 'ApprovalMessage');